export default __webpack_public_path__ + "static/Servicio Bodegaje-130940949aa1f1a597279b73121cd9cf.svg";